import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PageHeaderModule } from "@coso-replicator/core";
import { AlertMessageComponent, AlertModule as CosoAlertModule } from "@coso/alert";
import { FormsModule as CosoFormsModule } from "@coso/forms";
import { GridModule } from "@coso/grid";
import { OnPremLicenseModule } from "@coso/onprem-license";
import { UtilityModule } from "@coso/utility";
import { AlertModule } from "ngx-bootstrap/alert";
import { ButtonsModule } from "ngx-bootstrap/buttons";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { AddEditDatabaseConnectionComponent } from "./database-connections/add-edit-database-connection/add-edit-database-connection.component";
import { DatabaseConnectionsComponent } from "./database-connections/database-connections.component";
import { AddEditEmailNotificationProfileComponent } from "./email-notification-profiles/add-edit-email-notification-profile/add-edit-email-notification-profile.component";
import { EmailNotificationProfilesComponent } from "./email-notification-profiles/email-notification-profiles.component";
import { GlobalSettingsRoutingModule } from "./global-settings-routing.module";
import { GlobalSettingsComponent } from "./global-settings.component";

@NgModule({
    declarations: [GlobalSettingsComponent, EmailNotificationProfilesComponent, AddEditEmailNotificationProfileComponent, DatabaseConnectionsComponent, AddEditDatabaseConnectionComponent],
    imports: [
        CommonModule,
        GlobalSettingsRoutingModule,
        PageHeaderModule,
        OnPremLicenseModule,
        AlertModule,
        CosoAlertModule,
        FormsModule,
        ReactiveFormsModule,
        CosoFormsModule,
        ButtonsModule,
        UtilityModule,
        TooltipModule,
        GridModule,
        AlertMessageComponent
    ]
})
export class GlobalSettingsModule {}
